import React, { Component } from 'react';
import Api from './../Api'
import classes from "./../GS.module.css"

import ReactHtmlParser from "react-html-parser";

import Navbar from './Navbar/Navbar'

import { Link } from "react-router-dom";

class views extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contentArticle: {
                widgets: []
            },
            isLoaded: false,
            isApiloaded: false,
            views: null,
            idNews: '',
            querySearch: '',
            filtered: '',
            articleCategories: null,
            pagination: 6,
            articleID: null,
            displayStyle: 'grid',
            founded: null
        }
        this.getAllArticleDetail = this
            .getAllArticleDetail
            .bind(this);

        this.onFilterChange = this.onFilterChange.bind(this);
        this.getSearchedData = this.getSearchedData.bind(this);
        this.changeDisplay = this.changeDisplay.bind(this);
        this.loadMoreNews = this.loadMoreNews.bind(this);
        this.getAllCategories = this.getAllCategories.bind(this);

    }

    componentDidMount() {
        this.getAllCategories()
        this.setState({
            articleCategories: this.props.category ? this.props.category : '',
            querySearch: this.props.searchHere ? this.props.searchHere : ''
        })

        this.getAllArticleDetail('', this.state.filtered, this.props.searchHere ? this.props.searchHere : '')
    }

    getAllCategories() {

        const apiData = new Api()

        const categories = []

        this.setState({
            article_Categories: [],
        }, () => {

            apiData.getAllCategories().then(result => {
                const values = result.data
                const article_categories = []
                console.log(values)
                values.results.map((item) => {
                    if (item.category.includes("System")) {
                        //pass
                    } else {
                        article_categories.push(item.category)
                    }
                })

                this.setState({
                    articleCategories: article_categories,
                })
            })

        })

    }

    getAllArticleDetail(filter, size, search) {
        let count = 0
        if (count === 0) {
            const apiData = new Api();

            this.setState({
                contentArticle: []
            }, () => {
                const art = []

                apiData
                    .getAllArticleDetails(filter, size, search)
                    .then(result => {
                        const articles = result.data
                        articles
                            .results
                            .forEach((a) => {
                                const assets = []

                                a
                                    .article_assets
                                    .forEach((ass, i) => {
                                        if (i === 0) {
                                            assets.push({ asset: ass.asset_file })
                                        }
                                    })

                                art.push({
                                    id: a.id,
                                    category: a.category_name,
                                    name: a.name,
                                    title: a.article_languages.title,
                                    content: a.article_languages.content,
                                    assets: assets,
                                    date: a.date
                                })
                                this.setState({ contentArticle: art, founded: articles.count, isLoaded: true })
                            })


                    })
                    .catch(error => {
                        console.log(error);
                        this.setState({ isApiLoaded: true })
                    });


            })
        }

    }

    onFilterChange(e) {
        this.setState({
            filtered: e.target.value
        })
        this.getAllArticleDetail(e.target.value, '', this.state.querySearch)
    }

    loadMoreNews() {
        this.setState((prevState) => {
            return { pagination: prevState.pagination + 6 };
        });
    }

    getSearchedData(e) {
        if (e.keyCode === 13) {
            if (e.target.value !== "") {
                this.getAllArticleDetail('', '', e.target.value)
            }
        }
    }

    changeDisplay = (params) => {
        this.setState({ displayStyle: params })
    }

    render() {
        const { contentArticle, pagination } = this.state

        // SET CONTENT NEWS LIST MODE
        let apiContentlist = null
        if (this.state.isLoaded) {
            let count = 0

            apiContentlist = contentArticle.slice(0, pagination).map((s, i) => {
                count = count + 1
                let backgroundColor = null

                //console.log("A: " + this.state.articleCategories + " - " +  s.category)

                function getCategoryIndex(categoryList, category) {
                    var count = 1;
                    var returnValue = 0;
                    categoryList.forEach((thisCategory) => {
                        //console.log(thisCategory + " - " + category + " - " + thisCategory.localeCompare(category))
                        if (thisCategory.localeCompare(category) === 0) { returnValue = count }
                        count += 1;
                    })
                    return returnValue;
                }

                var categoryIndex = "";

                switch (getCategoryIndex(this.state.articleCategories, s.category)) {
                    case 1:
                        backgroundColor = classes.boxContent
                        break;
                    case 2:
                        backgroundColor = classes.boxContentL1
                        break;
                    default:
                        backgroundColor = classes.boxContentL2
                        break;
                }
                console.log(s)
                return (
                    <Link to={`${this.props.url}${s.id}`} className={classes.link}>
                        <div className={[classes.contentWrap, classes.fadeInBottom].join(' ')}>
                            <div className={backgroundColor}>
                                <div className={classes.contentBox}>
                                    {s.category}
                                </div>
                                <div className={classes.title_content}>
                                    {s.title}
                                </div>
                                <div className={classes.txt_content}>
                                    {ReactHtmlParser(s.content)}
                                </div>
                                <div className={classes.foot_content}>
                                    <p>{this.props.readMore}</p>
                                    <p className={classes.date_right}>
                                        {s.date}
                                    </p>
                                </div>
                            </div>
                            <div className={classes.boxImage}>
                                <figure className={classes.wrapp_image}>
                                    <img className={classes.img_content} src={s.assets[0] ? s.assets[0].asset : require('./assets/default-image.svg')} alt="description" /> {/* <div className={classes.inside_image}>test</div> */}
                                    <div className={classes.inside_image}>
                                        <img
                                            className={classes.icon_share}
                                            src={require("./../assets/Group 843.svg")}
                                            alt="description" />
                                        <br />
                                        <p>Share on :</p>
                                        <img
                                            className={classes.icon}
                                            src={require("./../assets/Subtraction 1.svg")}
                                            alt="description" />
                                        <img
                                            className={classes.icon}
                                            src={require("./../assets/Group 17.svg")}
                                            alt="description" />
                                        <img
                                            className={classes.icon}
                                            src={require("./../assets/Group 19.svg")}
                                            alt="description" />
                                        <img
                                            className={classes.icon}
                                            src={require("./../assets/Group 831.svg")}
                                            alt="description" />
                                    </div>
                                </figure>
                            </div>
                        </div>
                    </Link>
                )
            })
        }

        // SET CONTENT NEWS GRID MODE
        let apiContentGrid = null
        if (this.state.isLoaded) {
            apiContentGrid = contentArticle.slice(0, pagination).map((s, i) => {
                return (

                    <div className={[classes.contentWrap, classes.fadeInBottomm].join(" ")}>
                        <div className={classes.boxContent1}>
                            <div className={classes.contentBox}>
                                <div className={classes.backBox}>
                                    {s.category}
                                </div>
                            </div>
                            <div className={classes.box_behind}>
                                <div className={classes.box_content_image}>
                                    <img className={classes.box_image} src={s.assets[0] ? s.assets[0].asset : require('./assets/default-image.svg')} alt='description' />
                                </div>
                                <Link to={`${this.props.url}/${s.id}`} className={classes.link}>
                                    <div className={classes.div_readmore1}>
                                        <div className={classes.title_content1}>{s.title}</div>
                                        <div className={classes.foot_content1}>
                                            <p>{this.props.readMore}</p>
                                            <p className={classes.date_right1}>{s.date}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>

                )
            })
        }

        // SET NEWS CATEGORY
        let filters = null
        const { articleCategories } = this.state
        if (articleCategories) {
            filters = articleCategories.map(f => {
                return (
                    <option value={f}>{f}</option>
                )
            })
        }

        // CHANGE LIST/GRID VIEW
        let viewOnchange, colorList, colorGrid, nav = null
        if (this.state.displayStyle === '' || this.state.displayStyle === "list") {
            viewOnchange = <div className={classes.component}>{apiContentlist}</div>
            nav = <Navbar
                listClick={() => this.changeDisplay("list")}
                gridClick={() => this.changeDisplay("grid")}
                type={'list'}
                onKeyDown={this.getSearchedData}
                onChange={this.onFilterChange}
                category={articleCategories}
                title={this.props.title}
                searchHere={this.state.querySearch}
                total={this.state.founded}
                textFilter={this.props.textFilter}
                textFound={this.props.textFound}
                textSearch={this.props.textSearch}
            />
        } else {
            viewOnchange = <div className={classes.componentgrid}>
                <div className={["row", classes.box_grid].join(' ')}>
                    {apiContentGrid}
                </div>
            </div>
            nav = <Navbar
                listClick={() => this.changeDisplay("list")}
                gridClick={() => this.changeDisplay("grid")}
                type={'grid'}
                onKeyDown={this.getSearchedData}
                onChange={this.onFilterChange}
                category={articleCategories}
                title={this.props.title}
                searchHere={this.state.querySearch}
                total={this.state.founded}
                textFilter={this.props.textFilter}
                textFound={this.props.textFound}
                textSearch={this.props.textSearch}
            />
        }

        let contentNotFound = null
        if (this.state.isLoaded) {
            contentNotFound = !this.state.founded ?
                <div className={classes.contentNoResult}>
                    <div>
                        <img src={require('./assets/noresult.png')} alt='no-result'></img>
                        <p className={classes.warningResultText}><span style={{ color: '#F26522' }}>Sorry</span>, no result found</p>
                        <p style={{ textAlign: "center" }}>Try rewording your search or entering a new keyword.</p>
                    </div>
                </div> : ''
        }



        return (
            <>
                {/* <div className={classes.background_blur}></div> */}
                {nav}
                {contentNotFound}
                {viewOnchange}
                <div className={classes.older} onClick={this.loadMoreNews}>
                    <p>{this.props.loadMore}</p>
                </div>
            </>
        );
    }
}

export default views;